import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant';
import 'vant/lib/index.css';
import axios from 'axios'
import common from './utils/common.js'
const baseUrl = process.env.NODE_ENV === "production" ? '' : 'http://172.19.132.123:8080/api'
// const baseUrl = process.env.NODE_ENV === "production" ? '//rmrbh5.deyu5.com' : 'http://localhost:8080/api'

Vue.use(Vant);
Vue.config.productionTip = false
Vue.prototype.$http = axios;
Vue.prototype.$BASE_URL = baseUrl;
Vue.prototype.$common = common;

window.addEventListener('popstate', function () {
  router.isBack = true;
}, false)


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
